import {useEffect,useState} from 'react'
import {useDispatch} from 'react-redux'
import {
	setCreator,
	setEditor
} from './merchandiseSlice'
import {
	useMerchandiseItems,
	useMerchandiseOrders
} from '../hooks'
import {envAwarePost} from '../../../util/util'
import CenteredLoader from '../../CenteredLoader/CenteredLoader'
import Order from './Order/Order'
import Item from './Item/Item'
import Cart from './Cart/Cart'
import PurchaseModal from './PurchaseModal/PurchaseModal'
import Editor from './Editor/Editor'
import Creator from './Creator/Creator'
import styles from './Merchandise.module.css'
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js'
import useStripeAccount from '../../../hooks/useStripeAccount'
import Button from 'react-bootstrap/Button'
import Tabs from 'react-bootstrap/Tabs'
import Form from 'react-bootstrap/Form'
import Tab from 'react-bootstrap/Tab'
import useCurrentUser from '../../../hooks/useCurrentUser'
import {useHistory} from 'react-router-dom'
import {
	useCart
} from '../hooks'

const MyProducts = () => {
	const history = useHistory()
	const urlParams = new URLSearchParams(window.location.search)
	const filterId = parseInt(urlParams.get('product_id'))
	const dispatch = useDispatch()
	const {status:itemsStatus,ids:itemIds} = useMerchandiseItems()
	const {status:ordersStatus,ids:orderIds} = useMerchandiseOrders()
	const handleToggleEditor = () => { 
		dispatch(setEditor({id:false,show:true}))
	}
	const handleToggleCreator = ()=>{
		dispatch(setCreator({show:true}))
	}
	const user = useCurrentUser()
	const stripePromise = useStripeAccount(user?.trainer_stripe_account)

	const {hasItems,itemsQtyMap,grandTotal} = useCart()

	const [clientSecret,setClientSecret] = useState(null)
	const getPaymentIntent = (items)=>(
		envAwarePost(
			'api/merchandise/',
			{action:'getPaymentIntent',items}
		)
	)

	useEffect(async ()=>{
		if (!hasItems) return 
		const items = Object.entries(itemsQtyMap).map(([id,qty])=>({id,qty}))
		const res = await getPaymentIntent(items)
		setClientSecret(res.data.client_secret)
	},[grandTotal])


	console.log(clientSecret)


	return (
		<div style={{height:'100%',overflow:'auto'}} className="pb-5">
			<Tabs defaultActiveKey="items" id="merchandise-tabs" className="mb-3">
				<Tab eventKey="items" title="Items">
					{
						itemsStatus !== 'idle' ? 
						<CenteredLoader /> :
						<div>
							{user.account_type !== 'client'&&
								<div className="text-right mb-2">
									<Button 
										onClick={handleToggleCreator}
										variant="outline-success"
									>
										Add New Item
									</Button>
								</div>
							}
							<div className={styles.Controls}>
								<Form.Control placeholder="search"/>
							</div>
							{Boolean(filterId)&&
								<div className="mb-2">
									Viewing filtered list: 
									<Button 
										onClick={()=>{ 
											history.replace('/financials_dashboard/')
										}}
										variant="outline-danger" 
										className="ml-2"
										size="sm"
									>
										Clear Filters
									</Button>
								</div>
							}
							<div className={styles.ItemsGrid}>
								{itemIds.filter(id=>!Boolean(filterId)||id===filterId).map( id => <Item key={id} id={id}/> )}
							</div>
						</div>
					}
				</Tab>
				<Tab eventKey="orders" title="Orders">
					{
						ordersStatus !== 'idle' 
						? <CenteredLoader /> 
						:
						<div>
							<div className={styles.Controls}>
								<Form.Control placeholder="search"/>
							</div>
							<div className={styles.OrdersTable}>
								<div className={styles.OrdersHeader}>
									<div className="d-flex align-items-center">
										<div>
											Item
										</div>
										<div className="ml-auto" style={{width:'60px',textAlign:'right'}}>
											Fulfilled
										</div>
									</div>
								</div>
								{orderIds.map( id => <Order key={id} id={id}/> )}
							</div>
						</div>
					}
				</Tab>
				{user.account_type==='client'&&
					<Tab 
						eventKey="cart" 
						title={
							<span>
								Cart <i className="fas fa-shopping-cart ml-1"/>
							</span>
						}
					>
						<Cart/>
					</Tab>
				}
			</Tabs>
			<Editor/>
			<Creator/>
			{(Boolean(stripePromise)&&Boolean(clientSecret))&&
				<Elements stripe={stripePromise} options={{
					clientSecret
				}}>
					<ElementsConsumer>
						{({ elements, stripe }) => (
							<PurchaseModal
								elements={elements}
								stripe={stripe}
							/>
						)}
					</ElementsConsumer>
				</Elements>
			}
		</div>
	)
}


export default MyProducts